import { render } from "./FileList.vue?vue&type=template&id=524f3903&ts=true"
import script from "./FileList.vue?vue&type=script&lang=ts"
export * from "./FileList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__